<template>
  <div>
    <ManageGameTagTab />
  </div>
</template>

<script>
import ManageGameTagTab from './components/ManageGameTagTab.vue'

export default {
  name: 'GameTagManage',
  components: {
    ManageGameTagTab,
  },
}
</script>

<style scoped></style>
